<div class="outerItem">
    <div class="innerItem type{{ itemDTO.type }}" (click)="click()">
        <span class="caption">
            {{ itemDTO.message }}
        </span>
    </div>
</div>
